export default __webpack_public_path__ + "static/media/actividad-10.f9ecb6e5.mp3";